import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getConferencesAndEventsQueryOptions } from '@/_pages/conference-events/shared/api-service';

export const Route = createFileRoute('/_private/conferences-and-events/')({
  staticData: { isFullWidth: true },
  validateSearch: filterState.parse,
  loader: (opts) => opts.context.queryClient.ensureQueryData(getConferencesAndEventsQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={6} />,
});
